module.exports = __webpack_public_path__ + "font/64187f29.svg";